import React, { FC, useCallback, useState } from 'react';
import { Button, Card } from 'mui';
import { connect } from 'react-redux';
import { selectCustomer } from 'app/selectors/customer';
import * as Routes from 'app/constants/Routes';
import { push } from 'connected-react-router/immutable';
import { useAppDispatch } from 'app/helpers/hooks';
import ReferralLink from 'app/components/common/ReferralLink';
import ReferralModal from 'app/components/customer/Referral/ReferralModal';

const mapStateToProps = (state) => {
  const customer = selectCustomer(state);
  const activeProducts = customer.get('active_products_names');
  const hasActiveSubscription = activeProducts && activeProducts.size > 0;

  return {
    hasActiveSubscription,
    referralCode: customer.get('referral_code'),
    creditAmount: customer.get('credit_amount'),
  };
};

interface ReferralCardProps {
  hasActiveSubscription: boolean;
  referralCode: string;
  creditAmount: number;
}

const ReferralCard: FC<ReferralCardProps> = ({ hasActiveSubscription, referralCode, creditAmount }) => {
  const dispatch = useAppDispatch();
  const [showReferralModal, setShowReferralModal] = useState(false);

  const handleTrackReferrals = useCallback(() => {
    dispatch(push(Routes.TrackReferrals));
  }, []);

  const handleLearnMore = useCallback(() => {
    setShowReferralModal(true);
  }, []);

  if (!hasActiveSubscription) {
    return null;
  }

  return (
    <>
      <Card>
        <Card.Body>
          <h4>Give $50, get $50</h4>
          <p>
            When you refer a friend, they'll receive $50 off their first new plan, and you'll receive a $50 credit
            applied to your next bill.
          </p>

          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              handleLearnMore();
            }}
          >
            Learn More
          </a>

          <div className="bg-gray-100 text-center rounded-xl p-2 lg:p-4">
            <h4 className="text-[#0C144280]">${(creditAmount / 100).toFixed(2)}</h4>
            <p>Credit on Next Bill</p>
          </div>

          <ReferralLink referralCode={referralCode} />

          <Button variant="text" onClick={handleTrackReferrals}>
            Track referrals
          </Button>
        </Card.Body>
      </Card>
      <ReferralModal isOpen={showReferralModal} onClose={() => setShowReferralModal(false)} />
    </>
  );
};

export default connect(mapStateToProps)(ReferralCard);
